import * as React from "react";
import type { SVGProps } from "react";
const SvgTrash02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M2.4 5.4h19.2m-12 12v-7.2m4.8 7.2v-7.2m2.4 12H7.2a2.4 2.4 0 0 1-2.4-2.4V6.6A1.2 1.2 0 0 1 6 5.4h12a1.2 1.2 0 0 1 1.2 1.2v13.2a2.4 2.4 0 0 1-2.4 2.4M9.6 5.4h4.8a1.2 1.2 0 0 0 1.2-1.2V3a1.2 1.2 0 0 0-1.2-1.2H9.6A1.2 1.2 0 0 0 8.4 3v1.2a1.2 1.2 0 0 0 1.2 1.2"
    />
  </svg>
);
export default SvgTrash02;
